import React from 'react';
import useCollapse from 'react-collapsed';
import PercentBox from './PercentBox'
import {CSVLink, CSVDownload} from 'react-csv';
import {Button} from 'react-bootstrap';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import {Line} from 'react-chartjs-2';
import faker from 'faker';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

// const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

// export const data2 = {
//   labels,
//   datasets: [
//     {
//       label: 'Dataset 1',
//       data: labels.map(() => faker.datatype.number({ min: -1000, max: 1000 })),
//       borderColor: 'rgb(255, 99, 132)',
//       backgroundColor: 'rgba(255, 99, 132, 0.5)',
//     },
//     {
//       label: 'Dataset 2',
//       data: labels.map(() => faker.datatype.number({ min: -1000, max: 1000 })),
//       borderColor: 'rgb(53, 162, 235)',
//       backgroundColor: 'rgba(53, 162, 235, 0.5)',
//     },
//   ],
// };

export default function ChartLineCollapsed(props) {
  const {getCollapseProps, getToggleProps, isExpanded} = useCollapse({
    defaultExpanded: true
  });

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        align: 'end'
      },
      title: {
        display: true,
        text: props.chartdata.chart_name,
        position: 'bottom'
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        }
      },
      y: {
        grid: {
          display: false
        }
      }
    },
    interaction: {
      intersect: false,
      mode: 'index',
    }
  };
  const data = {
    labels: props.chartdata.chart_labels,
    datasets: props.chartdata.chart_datas
  };

  const rewardName = data.datasets.reduce( (prev, curr) => {
    if(curr.label !== 'Scan') return [...prev, curr.label];
    else return [...prev];
  },[]);

  return (
    <div className="card card-primary" id="card1">
      <div className="card-header">
        <h3 className="card-title">{props.chartdata.chart_name}</h3>
        <div className="card-tools">
          <button
            type="button"
            className="btn btn-tool"
            data-card-widget="collapse"
            {...getToggleProps()}
          >
            <i className={isExpanded ? 'fas fa-minus' : 'fas fa-plus'}></i>
          </button>
        </div>
      </div>
      <div className="card-body" {...getCollapseProps()}>
        <PercentBox left={data} leftlabel={["Scan"]} right={data} rightlabel={rewardName}></PercentBox>
        <div className="chart">
          <Line
            options={options}
            data={data}
            style={{
              minHeight: 260,
              height: 260,
              maxHeight: 260,
              maxWidth: '100%',
              display: 'block'
            }}
          />
        </div>
      </div>
      <div className="card-footer">
        <CSVLink
          filename={props.chartdata.chart_name}
          className="btn btn-primary"
          data={props.csvdata}
        >CSV</CSVLink>
        <Button variant="success" className='ml-2' onClick={()=>{props.export(props.csvdata, props.chartdata.chart_name)}}>Excel</Button>
      </div>
    </div>
  );
}
